import React from "react";
import { subscribeOnClickHandler } from "../../layout-utils";
import { getTextContrast } from "../../../../../utils";
import "./subscribe-button.m.css";

export const SubscribeButton = ({
  defaultSubscriptionHandler,
  mode,
  member,
  plan,
  subscriptionConfig,
  sso,
  separator = true,
}) => {
  const { buttonColor, darkButtonColor, subscribeButton } = subscriptionConfig;
  const updatedButtonColor = mode === "dark" ? darkButtonColor : buttonColor;
  const subscribeButtonColor = getTextContrast(updatedButtonColor);
  const updatedButtonText = subscribeButton || "Subscribe Now";

  return (
    <div styleName={`button-wrapper ${mode}`} className="subscribe-button">
      <button
        styleName="subscribe"
        data-test-id="subscribe-button"
        onClick={(e) => subscribeOnClickHandler(e, plan, sso, member, defaultSubscriptionHandler)}
        style={
          updatedButtonColor
            ? { background: updatedButtonColor, color: subscribeButtonColor === "dark" ? "#000" : "#fff" }
            : {}
        }
      >
        {updatedButtonText}
      </button>
      {separator && <div styleName="separator" />}
    </div>
  );
};
